<template>
  <!-- A company's details in a panel that slides in from the right, over the page it was opened from (Job Listings). The
       same details as on the Companies page. Closes with the cross, the dimmed area, or Escape. -->
  <Transition enter-active-class="transition-opacity duration-200 ease-out" enter-from-class="opacity-0" leave-active-class="transition-opacity duration-150 ease-in" leave-to-class="opacity-0">
    <div v-if="companyId" class="absolute inset-0 z-50 bg-slate-900/30 dark:bg-black/50" aria-hidden="true" @click="$emit('close')"></div>
  </Transition>

  <Transition enter-active-class="transition-transform duration-300 ease-[cubic-bezier(0.32,0.72,0,1)]" enter-from-class="translate-x-full"
    leave-active-class="transition-transform duration-200 ease-in" leave-to-class="translate-x-full" @after-enter="panel?.focus()">
    <aside v-if="companyId" ref="panel" role="dialog" aria-label="Company details" tabindex="-1" @keydown.esc="$emit('close')"
      class="absolute inset-y-0 right-0 z-[60] w-full sm:w-[85%] lg:w-[72%] lg:max-w-[980px] flex flex-col bg-white dark:bg-[#1C2128] border-l border-gray-200 dark:border-gray-700 shadow-[-12px_0_32px_-12px_rgba(15,23,42,0.35)] focus:outline-none">
      <header class="flex-shrink-0 flex items-center gap-3 px-5 h-14 border-b border-gray-100 dark:border-gray-700">
        <div class="min-w-0">
          <h2 class="text-sm font-semibold leading-tight text-gray-900 dark:text-white">Company</h2>
          <p class="text-xs text-gray-500 dark:text-gray-400 truncate">What is known about the company behind this job</p>
        </div>
        <IconButton class="ml-auto" :icon="CLOSE_ICON" label="Close" tone="plain" align="right" @click="$emit('close')" />
      </header>

      <div class="flex-1 min-h-0">
        <CompanyDetail :company="store.details[companyId] || null" :loading="store.detailLoading" :error="store.detailError" @retry="store.select(companyId)" />
      </div>
    </aside>
  </Transition>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useJobCompaniesStore } from 'stores/jobCompanies.js'
import IconButton from 'controllers/vue_components/shared/IconButton.vue'
import CompanyDetail from './CompanyDetail.vue'

const CLOSE_ICON = 'M6 18 18 6M6 6l12 12'

const props = defineProps({
  companyId: { type: String, default: null }, // the company to show; null keeps the panel closed
})
defineEmits(['close'])

const store = useJobCompaniesStore()
const panel = ref(null)

// Opening it loads the company (from the store's cache when it was seen already).
watch(() => props.companyId, (id) => { if (id) store.select(id) }, { immediate: true })
</script>
